import { AddCircle, CheckCircle, Unpublished } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import LoggedUser from "../../../model/auth/LoggedUser";
import Keyword from "../../../model/database/Keyword";
import ResearchProducer from "../../../model/database/ResearchProducer";
import ProductsFilters from "../../../model/filters/ProductsFilters";
import demandSortFields from "../../../model/table/sort/ProductSortFields";
import StringGeneratorUtil from "../../common/StringGeneratorUtil";
import TableToolbar from "../../common/table/TableToolbar";
import ProductsFiltersModal from "./ProductsFiltersModal";

interface ProdcutsTableToolbarProps {
    loggedUser?: LoggedUser,
    numSelected: number,
    producers: ResearchProducer[],
    keywords: Keyword[],
    handleNew: () => void,
    applyFilters: (filters: ProductsFilters) => void
    applySort: (sort: string) => void
}

const ProductsTableToolbar = ({
                                  loggedUser,
                                  numSelected,
                                  producers,
                                  keywords,
                                  handleNew,
                                  applyFilters,
                                  applySort
                              }: ProdcutsTableToolbarProps) => {

    const [updated, setUpdated] = React.useState<boolean>(false);
    const [filters, setFilters] = React.useState<ProductsFilters>(
        (loggedUser?.role === 'RESEARCH_PRODUCER') ? {
            producer: {
                label: 'Produttore',
                value: loggedUser?.idParent ?? loggedUser.id,
                valueDisplay: StringGeneratorUtil.generateProducerLabel(producers.find(value1 => !loggedUser.idParent ? value1.user?.id === loggedUser?.id : value1.user?.id === loggedUser.idParent)!)
            }
        } : {}
    );

    const handleConfirm = (newStateFilters: ProductsFilters) => {
        setFilters(newStateFilters);
        applyFilters(newStateFilters);
        setUpdated(true);
    }

    const handleClean = () => {
        setFilters({});
        applyFilters({});
        setUpdated(true);
    }

    const [openModal, setOpenModal] = React.useState<boolean>(false);
    const handleOpenModal = () => setOpenModal(true);
    const handleCloseModal = () => {
        setOpenModal(false);
    }

    React.useEffect(() => {
        if (!updated)
            setFilters(loggedUser?.role === 'RESEARCH_PRODUCER' ? {
                producer: {
                    label: 'Produttore',
                    value: loggedUser?.idParent ?? loggedUser.id,
                    valueDisplay: StringGeneratorUtil.generateProducerLabel(producers.find(value1 => !loggedUser.idParent ? value1.user?.id === loggedUser?.id : value1.user?.id === loggedUser.idParent)!)
                }
            } : {});
    }, [producers])

    return (
        <>
            <TableToolbar
                numSelected={numSelected}
                title="Prodotti"
                fields={demandSortFields}
                filters={Object.values(filters)}
                defaultField={demandSortFields[0].value}
                defaultOrder={'asc'}
                handleOpenFiltersModal={handleOpenModal}
                handleCleanFilters={handleClean}
                handleSort={applySort}
                handleExport={() => alert('export selection')}
                handleDelete={loggedUser && (loggedUser?.role === 'ADMINISTRATOR' || loggedUser?.role === 'RESEARCH_PRODUCER') ? () => alert('delete selection') : undefined}
                extendedActions={
                    <>
                        {loggedUser && (loggedUser?.role === 'ADMINISTRATOR' || loggedUser?.role === 'RESEARCH_PRODUCER') &&
                            <Tooltip title="Crea nuovo prodotto">
                                <IconButton color="secondary" onClick={handleNew}>
                                    <AddCircle/>
                                </IconButton>
                            </Tooltip>}
                    </>
                }
                extendedActionsOnSelection={
                    loggedUser && (loggedUser?.role === 'ADMINISTRATOR' || loggedUser?.role === 'COMMITTEE_MANAGEMENT') && <>
                        <Tooltip title="Approva">
                            <IconButton color="secondary">
                                <CheckCircle/>
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Disapprova">
                            <IconButton color="secondary">
                                <Unpublished/>
                            </IconButton>
                        </Tooltip>
                    </>
                }
            />
            <ProductsFiltersModal
                open={openModal}
                filters={filters}
                producers={producers}
                loggedUser={loggedUser}
                keywords={keywords}
                handleClose={handleCloseModal}
                handleClean={handleClean}
                handleConfirm={handleConfirm}
            />
        </>
    );
}

export default ProductsTableToolbar;
